import React from "react";

function UpdateInfoLayout(props) {
  return (
    <>
      <div className="text-center">
        <h3 className="modal-title">{props.title}</h3>
        {!!props?.handleBack && (
          <a
            onClick={props.handleBack}
            style={{ cursor: "pointer",color:"#ffffff", fontSize: "13px",  }}
            className="m-0 d-flex align-items-center cursor-pointer justify-content-end backbtn"
          >
            <span className="material-symbols-outlined ">
              keyboard_arrow_left
            </span>
            Back
          </a>
        )}
      </div>
      <div className="form-group mt-4">
        <div className="row">
          {props.children}
        </div>
      </div>
      <div className="mt-4">
        <button
          type="submit"
          className="btn btn-primary rounded-pill w-100 p-2"
          disabled={props.isSubmitDisabled}
        >
          Save Details
        </button>
      </div>
    </>
  );
}

export default UpdateInfoLayout;
